import React from 'react';

type HeaderProps = {
  title: string;
  subtitle?: string;
  className?: string;
};

function Header({title, subtitle, className}: HeaderProps) {
  return (
    <div className={className}>
      <h3 className={`text-4xl font-bold`}>{title}</h3>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
  );
}

export default Header;
